var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19769 14.6393H20.8971M2.9739 14.6393V6.42467H5.2208M19.4032 14.6393V6.42467H17.0127M11.1885 0.948242L16.665 3.68646V14.6393H5.71211V3.68646L11.1885 0.948242ZM9.81944 14.6393V10.532H12.5577V14.6393H9.81944ZM11.1885 7.79378C10.4324 7.79378 9.81944 7.1808 9.81944 6.42467C9.81944 5.66854 10.4324 5.05557 11.1885 5.05557C11.9447 5.05557 12.5577 5.66854 12.5577 6.42467C12.5577 7.1808 11.9447 7.79378 11.1885 7.79378Z",
    stroke: "#A3B18A",
    strokeWidth: 1.36911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDos);
export default __webpack_public_path__ + "static/media/iconDos.66cb8b77520f6773de50bcb7f63d3ab8.svg";
export { ForwardRef as ReactComponent };